module.exports = "../../../../platform/assets/pageMainIcon/ig-business-processing-3.svg";